import { render } from "./Radar1Charts.vue?vue&type=template&id=c061ff28&scoped=true"
import script from "./Radar1Charts.vue?vue&type=script&lang=js"
export * from "./Radar1Charts.vue?vue&type=script&lang=js"

import "./Radar1Charts.vue?vue&type=style&index=0&id=c061ff28&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c061ff28"]])

export default __exports__